'use client';

import api from '@/axiosSetup';
import React, { createContext, useCallback, useContext, useMemo, useRef } from 'react';
import { useGlobalContext } from './context';
import { useBookingsBoxContext } from './bookings-box-context';
import toast from 'react-hot-toast';
import { useTranslations } from 'next-intl';
import { backupUsersBookedDay } from '@/utils/Backups';
import { convertISODateToReadable } from '@/utils/UtilityScripts';
import { getSpecialClientType } from '@/utils/GetSpecialClientType';
import { useBookingPolicy } from './booking-policy-context';

const BookingsFunctionalityContext = createContext(null);

export function BookingsFunctionalityProvider({ children }) {
  const { requireBookingsEnabled, reportBookingPolicyError } = useBookingPolicy();
  const bookingSubmissionRef = useRef(false);
  // ===== GLOBAL CONTEXT =====
  const {
    // core user/admin
    user, admin, users, setUsers,

    // calendar/day state
    days, setDays, newUsersBooked, setNewUsersBooked,
    activeDay, setActiveDay, activeDayObj, setActiveDayObj,
    userCurrentRooms, setUserCurrentRooms,

    // modes / toggles
    viewEventsMode, setViewEventsMode, userViewSpots, setUserViewSpots,

    // UI modals
    setAddUserConfirmModal, setOpenDecideClientBookingModal, setOpenAddUserTable,
    openStripeModalAdmin, setOpenStripeModalAdmin,

    // period/year
    period, setPeriod, year, setYear,
    currentMonth, currentYear,

    // misc
    alertMessage, setAlertMessage, alertModal, setAlertModal,
    selectedPerson, setSelectedPerson,
    realClientInfoObj, setRealClientInfoObj,
    clientGuestInfoObj, setClientGuestInfoObj,
    bookedWithCard, setBookedWithCard,

    activeDates, setActiveDates,
    SCActiveDates, setSCActiveDates,
    multipleSpecialClientBookings, setMultipleSpecialClientBookings,
    applyMultiDates, setApplyMultiDates,
    creditCardAdminEmailInfoObj,
    actionLoader, setActionLoader,
    locale,

    // helpers you said are in global (or imported where your GC lives)
    clientNotesModal,
    setClientNotesModal,
    setUsersBooked,
    setDisableStripeConfirmBtn
  } = useGlobalContext();

  //TOAST
  const tSuccessToastMessages = useTranslations('SuccessToastMessages');
  const tErrorToastMessages = useTranslations('ErrorToastMessages');

  // ===== PERIOD BOX CONTEXT =====
  const {
    periodDays, setPeriodDays, getPeriodDays,
  } = useBookingsBoxContext();

  // small helper
  const delay = useCallback((ms) => new Promise(res => setTimeout(res, ms)), []);

  // ---------------- EMAIL SENDERS ----------------

  // GOES TO ADMIN !!!!!!!!!!!!!!!!
  const sendGridMail = useCallback(async (selectedPerson, _combinedPMDetails) => {
    // Do multiple and single booked users
      const datesToBook = userViewSpots
      ? (activeDates ?? [])
      : activeDayObj?.date?.split('T')[0]

      // console.log('creditCardAdminEmailInfoObj', creditCardAdminEmailInfoObj)
      console.log('_combinedPMDetails', _combinedPMDetails)

      // console.log('datesToBook', datesToBook)

      // BOOKED WITH MONEY !!!!!!!!!!!!!!!!!!!!!!!
    if (bookedWithCard) {
      if (!userViewSpots) // NOT multiple users
      {
        try {
          const body = {
            user: selectedPerson,
            addedDate: String(datesToBook),
            admin,
            year,
            period,
            clientGuestInfoObj,
            bookedWithCard,
            combinedPMDetails: _combinedPMDetails,
            // combinedPMDetails: creditCardAdminEmailInfoObj?.combinedPMDetails,
            realClientInfoObj,
            multipleSpecialClientBookings,
          };
          await api.post('/api/send-admin-book/card', body, { headers: { 'Content-Type': 'application/json' } });
        } catch (err) {
          // swallow and reset same as your existing logic
        } finally {
          setBookedWithCard(null);
        }
      } else if (datesToBook.length > 0) {
        // MULTIPLE users
        try {
          const body = {
            user: selectedPerson,
            datesList: datesToBook,
            admin,
            year,
            period,
            clientGuestInfoObj,
            bookedWithCard,
            combinedPMDetails: _combinedPMDetails,
            realClientInfoObj,
            // multipleSpecialClientBookings,
          };
          await api.post('/api/send-admin-book/card-multiple', body, { headers: { 'Content-Type': 'application/json' } });
        } catch (err) {
          // swallow and reset same as your existing logic
        } finally {
          setBookedWithCard(null);
        }
      }
    } else {

      // BOOKED WITH-OUT MONEY !!!!!!!!!!!!!!!!!!!!!!!
      if (!userViewSpots) // NOT multiple users
      {
        // NOT multiple users
        console.log('datesToBook', String(datesToBook))
        try {
          const body = {
            user: selectedPerson,
            addedDate: String(datesToBook),
            admin,
            year,
            period,
            clientGuestInfoObj,
            bookedWithCard: false,
            realClientInfoObj,
            multipleSpecialClientBookings,
          };
          await api.post('/api/send-admin-book/free', body, { headers: { 'Content-Type': 'application/json' } });
        } catch (err) {
        } finally {
          setBookedWithCard(null);
        }
      } else if (datesToBook.length > 0) {
        // MULTIPLE users
        try {
          const body = {
            user: selectedPerson,
            datesList: datesToBook,
            admin,
            year,
            period,
            clientGuestInfoObj,
            bookedWithCard: false,
            realClientInfoObj,
          };
          await api.post('/api/send-admin-book/free-multiple', body, { headers: { 'Content-Type': 'application/json' } });
        } catch (err) {
        } finally {
          setBookedWithCard(null);
        }
      }
    }
  }, [
    admin, year, period, clientGuestInfoObj, bookedWithCard,
    creditCardAdminEmailInfoObj, realClientInfoObj, multipleSpecialClientBookings, setBookedWithCard
  ]);

  const sendGridMailMultipleSpecialClientsAdmin = useCallback(async (datesList) => {
    try {
      const body = {
        selectedSpecialClient: selectedPerson,
        datesList,
        admin,
        clientGuestInfoObj,
        multipleSpecialClientBookings,
      };
      console.log('1 body', body)
      await api.post('/api/send-admin-book/multiple-special-clients', body, {
        headers: { 'Content-Type': 'application/json' }
      });
    } catch (err) {
      // log if you want
    } finally {
      setBookedWithCard(null);
    }
  }, [selectedPerson, admin, clientGuestInfoObj, multipleSpecialClientBookings, setBookedWithCard]);


  // USER/CLIENT EMAILS ONLY!!!
  const sendGridMailByAdminToUser = useCallback(async (combinedPMDetails) => {
    const datesToBook = userViewSpots
      ? (activeDates ?? [])
      : [activeDayObj?.date?.split('T')[0]];

    if (bookedWithCard) { //PAID
      if (!userViewSpots) { // SINGLE DAY
        // PAID!
        try {
          // const getActiveDateSplit = activeDayObj.date.split('T')[0];
          const body = {
            selectedPerson,
            activeDate: datesToBook[0],
            year,
            period,
            admin,
            bookedWithCard: true,
            combinedPMDetails, //Card info
            locale: locale,
        }
        const response = await api.post('/api/send-client-admin-book/single-day', body, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
          console.log('RESPONSE', response);
        } catch (error) {
          console.error('Error creating email', err);
        }

      } else { // MULTIPLE USER VALID DAYS
        const body = {
            selectedPerson,
            datesList: datesToBook,
            year,
            period,
            admin,
            bookedWithCard: true,
            combinedPMDetails,
            locale,
          };
          await api.post('/api/send-client-admin-book/multiple-days', body, {
            headers: { 'Content-Type': 'application/json' }
          });
      }
    }
    else { // FREE
      
      if (!userViewSpots) {  // SINGLE DAY
      // FREE!
        try {
          // const getActiveDateSplit = activeDayObj.date.split('T')[0];
          const body = {
            selectedPerson,
            activeDate: datesToBook[0],
            year,
            period,
            admin,
            bookedWithCard: false,
            combinedPMDetails: {
              name: '',
              country: '',
              postalCode: '',
              phone: '',
              email: selectedPerson?.email ?? '',
              brand: '',
              last4: '',
            },
            locale,
          };
          await api.post('/api/send-client-admin-book/single-day', body, {
            headers: { 'Content-Type': 'application/json' }
          });
        } catch (err) {
          console.error('Error creating email', err);
        }
      } else { // MULTIPLE USER VALID DAYS

        try {
          const body = {
            selectedPerson,
            datesList: datesToBook,
            year,
            period,
            admin,
            bookedWithCard: false,
            combinedPMDetails: {
              name: '',
              country: '',
              postalCode: '',
              phone: '',
              email: selectedPerson?.email ?? '',
              brand: '',
              last4: '',
            },
            locale,
          };
          await api.post('/api/send-client-admin-book/multiple-days', body, {
            headers: { 'Content-Type': 'application/json' }
          });
        } catch (err) {
          console.error('Error creating email', err);
        }
      }
    }
  }, [bookedWithCard, activeDayObj, selectedPerson, year, period, admin, locale]);

  // ---------------- CORE OPS ----------------

  const handleMultipleSpecialClients = useCallback(async () => {
    if (!(await requireBookingsEnabled())) return false;
    try {
      console.log("Jesus")
      const datesList = SCActiveDates;
      const clientType = getSpecialClientType(selectedPerson);
      let specialClients;

      for (let i = 0; i < multipleSpecialClientBookings; i++) {
        const response = await api.post(
          `/api/special-clients/multiple?&clientType=${clientType}&period=${period}`,
          { clientGuestInfoObj, admin, datesList }
        );

        const { password, ...adminWithoutPassword } = admin || {};
        const bookingType = response.data.bookingType || 'unknown';

        specialClients = response.data.specialClients;

        for (const specialClient of specialClients) {
          await delay(600); // your existing stagger
          const roomDateISO = specialClient.roomDate.split('T')[0];

          // update local days
          const dayIndex = days.findIndex((d) => d.date.split('T')[0] === roomDateISO);
          if (dayIndex !== -1) {
            const updated = [...days];
            updated[dayIndex].specialClientsBookedIds.push({
              clientId: specialClient._id,
              type: clientType,
              owner: adminWithoutPassword,
              bookingType,
            });
            updated[dayIndex].usersBooked.push(specialClient);

            setNewUsersBooked({
              newUsersBooked: updated[dayIndex].usersBooked,
              activeDay: roomDateISO,
              maxSpotsAvailable: updated[dayIndex].maxSpotsAvailable,
            });

            backupUsersBookedDay(updated[dayIndex]._id, updated[dayIndex].usersBooked);

            // NOTE: if you needed setDays(updated) uncomment
            // setDays(updated);
          }
        }

        setAddUserConfirmModal(false);
        setOpenAddUserTable(false);

        const old = activeDay;
        setActiveDay('');
        setTimeout(() => setActiveDay(old), 100);

        // update periodDays mirror
        for (const specialClient of specialClients) {
          const roomDateISO = specialClient.roomDate.split('T')[0];
          setPeriodDays(previous => previous.map((obj) => {
            if (obj.date.split('T')[0] === roomDateISO) {
              return {
                ...obj,
                specialClientsBookedIds: [
                  ...obj.specialClientsBookedIds.filter(entry => String(entry.clientId) !== String(specialClient._id)),
                  { clientId: specialClient._id, owner: adminWithoutPassword, bookingType },
                ],
              };
            }
            return obj;
          }));
        }
      }

      // New Success call ////////////////////// Already do??
      // const clientDisplay =
      //   selectedPerson?.firstName?.trim() || 'Service client';

      // const total = specialClients?.length ?? 0;

      // // 👉 unique dates (ISO -> readable)
      // const isoFromSC =
      //   specialClients?.map(sc => sc.roomDate?.split('T')[0]).filter(Boolean) ?? [];
      // const uniqueISO = [...new Set(isoFromSC.length ? isoFromSC : datesList)];
      // const datesCount = uniqueISO.length;
      // const humanDates = uniqueISO.map(d => convertISODateToReadable(d)).join(', ');

      // const bookingWord = total === 1 ? 'booking' : 'bookings';
      // const verb = total === 1 ? 'was' : 'were';

      // toast.success(
      //   `${total} ${bookingWord} for ${clientDisplay} ${verb} created successfully.` +
      //   (datesCount ? ` (${datesCount} ${datesCount === 1 ? 'date' : 'dates'}${humanDates ? ` — ${humanDates}` : ''})` : '')
      // );

      await sendGridMailMultipleSpecialClientsAdmin(datesList);
    } catch (error) {
      // Let the shared booking handler stop before success notifications.
      throw error;
    }
  }, [
    SCActiveDates, multipleSpecialClientBookings, selectedPerson, period,
    clientGuestInfoObj, admin, days, setNewUsersBooked, backupUsersBookedDay,
    activeDay, periodDays, setPeriodDays, setAddUserConfirmModal, setOpenAddUserTable,
    setActiveDay, delay, getSpecialClientType, sendGridMailMultipleSpecialClientsAdmin, requireBookingsEnabled
  ]);


  const handleAddUserPressed = useCallback(async (_combinedPMDetails) => {
    if (bookingSubmissionRef.current) return;
    bookingSubmissionRef.current = true;
    try {
      if (!(await requireBookingsEnabled())) {
        // If the switch changed after a card payment, retain the existing
        // payment-review warning rather than suggesting a fresh attempt.
        if (_combinedPMDetails) toast.error(tErrorToastMessages('PaidBookingNeedsReview'), { duration: 12000 });
        setActionLoader(false);
        setDisableStripeConfirmBtn(false);
        return;
      }
      setActionLoader(true);
      // SPECIAL CLIENT BRANCH
      const isSpecial =
        selectedPerson?.membershipCode === process.env.NEXT_PUBLIC_HOTEL_MEMBERSHIPCODE ||
        selectedPerson?.membershipCode === process.env.NEXT_PUBLIC_CASINO_MEMBERSHIPCODE ||
        selectedPerson?.membershipCode === process.env.NEXT_PUBLIC_EVENTS_MEMBERSHIPCODE ||
        selectedPerson?.membershipCode === process.env.NEXT_PUBLIC_GRAT_MEMBERSHIPCODE ||
        selectedPerson?.membershipCode === process.env.NEXT_PUBLIC_CASINO_OWNER_MEMBERSHIPCODE;

      if (isSpecial) {
        
        if (applyMultiDates) { //Literally books multiple service clients
          if (await handleMultipleSpecialClients() === false) {
            setActionLoader(false);
            setDisableStripeConfirmBtn(false);
            return;
          }
        
        } else {
          // single special-client booking
          const clientType = getSpecialClientType(selectedPerson);

          for (let i = 0; i < multipleSpecialClientBookings; i++) {
            const response = await api.post(
              `/api/special-clients?date=${activeDay}&period=${period}&clientType=${clientType}`,
              { clientGuestInfoObj, admin }
            );

            const { password, ...adminWithoutPassword } = admin || {};
            const specialClient = response.data.specialClient;
            const bookingType = response.data.bookingType || 'unknown';

            // update local "days"
            const dayIndex = days.findIndex((d) => d.date === activeDayObj.date);
            if (dayIndex !== -1) {
              const updated = [...days];
              updated[dayIndex].specialClientsBookedIds.push({
                clientId: specialClient._id,
                type: clientType,
                owner: adminWithoutPassword,
                bookingType,
              });
              updated[dayIndex].usersBooked.push(specialClient);

              setNewUsersBooked({
                newUsersBooked: updated[dayIndex].usersBooked,
                activeDay,
                maxSpotsAvailable: updated[dayIndex].maxSpotsAvailable,
              });

              backupUsersBookedDay(updated[dayIndex]._id, updated[dayIndex].usersBooked);

              // mirror into periodDays
              setPeriodDays(previous => previous.map((obj) => {
                if (obj.date.split('T')[0] === activeDayObj.date.split('T')[0]) {
                  return {
                    ...obj,
                    specialClientsBookedIds: [
                      ...obj.specialClientsBookedIds.filter(entry => String(entry.clientId) !== String(specialClient._id)),
                      { clientId: specialClient._id, owner: adminWithoutPassword, bookingType },
                    ],
                  };
                }
                return obj;
              }));
            }
          }

          // New
          const capitalFirstName = (selectedPerson.firstName || '').toUpperCase();
          const capitalLastName = (selectedPerson.lastName || '').toUpperCase();
          toast.success(
            tSuccessToastMessages('DateForUserWasSuccessfullyBooked', {
              firstName: capitalFirstName,
              lastName: capitalLastName,
              date: convertISODateToReadable(activeDayObj.date.split('T')[0]),
            })
          );
          // toast.success(
          //   tSuccessToastMessages('DateForServiceClientWasSuccessfullyBooked', {
          //     firstName: specialClient.firstName,
          //     date: convertISODateToReadable(activeDayObj.date.split('T')[0]),
          //   })
          // );

          setAddUserConfirmModal(false);
          setOpenAddUserTable(false);
          const old = activeDay;
          setActiveDay('');
          setTimeout(() => setActiveDay(old), 100);
          // await sendGridMail(selectedPerson, activeDayObj.date); // DO NOT TURN ON
        }
      } else {

        // USER BOOKING BRANCH ////////////////////////////////////////////////// 
        // Do multiple and single booked users
        const datesToBook = userViewSpots
        ? (activeDates ?? [])
        : [activeDayObj?.date?.split('T')[0]];

        for (const isoDate of datesToBook) {
          // find the day object for this date
            const dayObj = days.find(d => d.date.split('T')[0] === isoDate);
            if (!dayObj) {
              // skip if not found (or handle as error)
              continue;
            }

          const response = await api.patch(
            `/api/day-add-user/${dayObj._id}?date=${isoDate}&membershipCode=${selectedPerson.membershipCode}&year=${year}&period=${period}&clientId=${selectedPerson._id}&bookedWithCard=${bookedWithCard}`,
            { admin, realClientInfoObj }
          );
  
          const { password, ...adminWithoutPassword } = admin || {};
          const bookingType = response.data.bookingType || 'unknown';
  
          const updatedSelectedPerson = {
            ...selectedPerson,
            allRooms: [
              ...selectedPerson.allRooms,
              { date: isoDate, owner: adminWithoutPassword, notes: realClientInfoObj.notes },
            ],
          };
  
          // update "days"
          const dayIndex = days.findIndex((d) => d.date.split('T')[0] === isoDate);
          if (dayIndex !== -1) {
            const updated = [...days];
            updated[dayIndex].usersBookedMCodes.push({
              mCode: updatedSelectedPerson.membershipCode,
              owner: adminWithoutPassword,
              notes: realClientInfoObj.notes,
              bookingType,
            });
            updated[dayIndex].usersBooked.push(updatedSelectedPerson);
  
            setNewUsersBooked({
              newUsersBooked: updated[dayIndex].usersBooked,
              activeDay: isoDate,
              maxSpotsAvailable: updated[dayIndex].maxSpotsAvailable,
            });
  
            backupUsersBookedDay(updated[dayIndex]._id, updated[dayIndex].usersBooked);
          }
  
          const getUser = users.find((u) => u.membershipCode === selectedPerson.membershipCode);
          if (getUser) {
            getUser.allRooms.push({
              date: isoDate,
              owner: adminWithoutPassword,
            });
            setUsers([...users]);
            setUsersBooked([...users]);
          }
  
           // Update periodDays MCodes for THIS date
          setPeriodDays(previous => previous.map(obj => {
            const objDate = obj.date.includes('T') ? obj.date.split('T')[0] : obj.date;
            if (objDate === isoDate) {
              return {
                ...obj,
                usersBookedMCodes: [
                  ...obj.usersBookedMCodes.filter(entry => String(entry.mCode) !== String(selectedPerson.membershipCode)),
                  { mCode: selectedPerson.membershipCode, owner: adminWithoutPassword, notes: realClientInfoObj.notes, bookingType },
                ],
              };
            }
            return obj;
          }));

          setAddUserConfirmModal(false);
          setOpenAddUserTable(false);
          const old = activeDay;
          setActiveDay('');
          setTimeout(() => setActiveDay(old), 100);
  
          setTimeout(async () => {
              if (userViewSpots && userViewSpots._id === response.data.user._id ) {
                const response2 = await api.get(`/api/users/with-history/${response.data.user.membershipCode}`);
                setUserViewSpots(response2.data.user);
                // remove ALL active-event classes
                setTimeout(() => {
                  document.querySelectorAll('.day.active-event')
                    .forEach(el => el.classList.remove('active-event'));
                    setActiveDay('');
                    setActiveDayObj(null);
                }, [500])
              }
            }, [500])
  
            setOpenStripeModalAdmin(false);
            setOpenDecideClientBookingModal(false);
            setBookedWithCard(null);
            
          // Checks if date has reached its limit (sends emails)
          if (!applyMultiDates) {
            const capitalFirstName = (selectedPerson.firstName || '').toUpperCase();
            const capitalLastName = (selectedPerson.lastName || '').toUpperCase();
    
            await api.post(`/api/days/date`, { date: [isoDate] });
            await getPeriodDays(currentMonth, currentYear);
    
            toast.success(
              tSuccessToastMessages('DateForUserWasSuccessfullyBooked', {
                firstName: capitalFirstName,
                lastName: capitalLastName,
                date: convertISODateToReadable(activeDayObj.date.split('T')[0]),
              })
            );
          }
        }
      }

      if (applyMultiDates) {
        const capitalFirstName = (selectedPerson.firstName || '').toUpperCase();
        const capitalLastName = (selectedPerson.lastName || '').toUpperCase();

        // Checks if date has reached its limit (sends emails)
        await Promise.all(
          SCActiveDates.map(async (date) => {
            try {
              await api.post(`/api/days/date`, { date: [date] });
              await getPeriodDays(currentMonth, currentYear);
              toast.success(
                tSuccessToastMessages('DateForUserWasSuccessfullyBooked', {
                  firstName: capitalFirstName,
                  lastName: capitalLastName,
                  date: convertISODateToReadable(date),
                })
              );
            } catch (err) {
              toast.error(
                tErrorToastMessages('DateBookingFailed', { date: convertISODateToReadable(date) })
              );
            }
          })
        );
      }

      // Was sending unneccessary emails with applyMultiDates
      if (!applyMultiDates) {
        // admin email
        await sendGridMail(selectedPerson, _combinedPMDetails);
        // client email (free AND paid!)
        await sendGridMailByAdminToUser(_combinedPMDetails);
      }

      setActionLoader(false);
      setClientGuestInfoObj((prev) => ({ ...prev })); // no-op but keeps parity with your flow
      setClientNotesModal(false);
      setDisableStripeConfirmBtn(false);
    } catch (error) {
      setDisableStripeConfirmBtn(false);
      setBookedWithCard(null);
      setOpenDecideClientBookingModal(false);
      setAddUserConfirmModal(false);
      setOpenStripeModalAdmin(false);
      setActionLoader(false);
      if (_combinedPMDetails || !reportBookingPolicyError(error)) {
        toast.error(tErrorToastMessages(
          _combinedPMDetails ? 'PaidBookingNeedsReview' : 'DateCouldNotBeBooked'
        ), { duration: _combinedPMDetails ? 12000 : 4000 });
      }
      console.error('Date could not be booked:', error);
    } finally {
      bookingSubmissionRef.current = false;
    }
  }, [
    setActionLoader, selectedPerson, applyMultiDates, handleMultipleSpecialClients, activeDay,
    period, clientGuestInfoObj, admin, days, activeDayObj, setNewUsersBooked, backupUsersBookedDay,
    periodDays, setPeriodDays, setAddUserConfirmModal, setOpenAddUserTable, setActiveDay, users,
    setUsers, userViewSpots, setUserViewSpots, sendGridMail, setOpenStripeModalAdmin,
    setOpenDecideClientBookingModal, setBookedWithCard, sendGridMailByAdminToUser,
    getPeriodDays, currentMonth, currentYear, tSuccessToastMessages, tErrorToastMessages,
    toast, SCActiveDates, year, requireBookingsEnabled, reportBookingPolicyError, setDisableStripeConfirmBtn
  ]);

  const handleDetermineAddUserOrSpecialClient = useCallback(() => {
    const divElement = document.querySelector('.active-event');

    if (divElement && divElement.classList.contains('old')) {
      // allow booking in past if marked 'old'
      handleAddUserPressed();
      return;
    }

    const isSpecial =
      selectedPerson?.membershipCode === process.env.NEXT_PUBLIC_HOTEL_MEMBERSHIPCODE ||
      selectedPerson?.membershipCode === process.env.NEXT_PUBLIC_CASINO_MEMBERSHIPCODE ||
      selectedPerson?.membershipCode === process.env.NEXT_PUBLIC_EVENTS_MEMBERSHIPCODE ||
      selectedPerson?.membershipCode === process.env.NEXT_PUBLIC_GRAT_MEMBERSHIPCODE ||
      selectedPerson?.membershipCode === process.env.NEXT_PUBLIC_CASINO_OWNER_MEMBERSHIPCODE;

    if (isSpecial) {
      // go straight to adding
      handleAddUserPressed();
    } else {
      // user path: open the Stripe/free decision modal
      setAddUserConfirmModal(false);
      setOpenDecideClientBookingModal(true);
    }
  }, [selectedPerson, handleAddUserPressed, setAddUserConfirmModal, setOpenDecideClientBookingModal]);

  const value = useMemo(() => ({
    handleDetermineAddUserOrSpecialClient,
    handleAddUserPressed,
    handleMultipleSpecialClients,
    sendGridMail,
    sendGridMailMultipleSpecialClientsAdmin,
    sendGridMailByAdminToUser,
  }), [
    handleDetermineAddUserOrSpecialClient,
    handleAddUserPressed,
    handleMultipleSpecialClients,
    sendGridMail,
    sendGridMailMultipleSpecialClientsAdmin,
    sendGridMailByAdminToUser,
  ]);

  return (
    <BookingsFunctionalityContext.Provider value={value}>
      {children}
    </BookingsFunctionalityContext.Provider>
  );
}

export function useBookingsFunctionality() {
  const ctx = useContext(BookingsFunctionalityContext);
  if (!ctx) throw new Error('useBookingsFunctionality must be used within <BookingsFunctionalityProvider>');
  return ctx;
}
